
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SubUnitEdit from '@/components/SubUnit/SubUnitEdit.vue';

@Component({
  components: {
    SubUnitEdit,
  },
})
export default class SubUnitEditButton extends Vue {
  @Prop(String) private id!: string;
  private showDialog = false;

  @Emit()
  private subUnitUpdated() {
    this.showDialog = false;
  }
}
